import { ref } from 'vue'

export function usePagination(initialPage: number = 1) {
    const page = ref(initialPage)

    const nextPage = () => {
        page.value++
    }

    const resetPage = () => {
        page.value = initialPage
    }

    const currentPage = () => {
        return page.value
    }

    return {
        page,
        nextPage,
        resetPage,
        currentPage,
    }
}
